/* =========================================================================
   Pending session summary — holds a guest game's final summary so it can be
   submitted right after the player creates an account (or signs in) from the
   tally screen's "save your score" prompt. Imports only api.ts (no cycles).
   ========================================================================= */
import { completeSession, type CompleteSessionPayload } from './api';

let pending: CompleteSessionPayload | null = null;

export function setPendingSummary(p: CompleteSessionPayload): void {
  pending = p;
}

export function clearPendingSummary(): void {
  pending = null;
}

/** Submit the held summary (if any) now that the player is authenticated.
    Clears the slot BEFORE awaiting so a double trigger can never submit twice. */
export async function flushPendingSummary(): Promise<boolean> {
  if (!pending) return false;
  const payload = pending;
  pending = null;
  const r = await completeSession(payload);
  return r.ok;
}
